import { useEffect, useState } from 'react';

const VisitorCounter = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    fetch('/api/visitors.php')
      .then((r) => r.json())
      .then((d) => setCount(d.count))
      .catch(() => {});
  }, []);

  if (count === null) return null;

  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        bottom: 18,
        right: 20,
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: 10,
        color: 'var(--ink-3)',
        opacity: 0.45,
        zIndex: 40,
        pointerEvents: 'none',
        letterSpacing: '0.05em',
        userSelect: 'none',
      }}
    >
      {count.toLocaleString()} unique visitors
    </div>
  );
};

export default VisitorCounter;
